import { IProspectQuoteForm, IProspectQuotePayload } from 'quotes/types';

/**
 * companyName is sent even when the domain lookup matched an existing company — the BE resolves
 * the company from the email domain and discards this value, so it is only read on a fresh domain.
 */
export const mapProspectQuoteForm = (data: IProspectQuoteForm): IProspectQuotePayload => ({
  companyName: data.companyName?.trim() ?? '',
  email: data.email?.trim() ?? '',
  firstName: data.firstName?.trim() ?? '',
  lastName: data.lastName?.trim() ?? '',
});
